
import Vue from "vue";
import { DefaultEditTab, getVisibleDefaultEditTabs } from "@/utils/tabs/default-edit-tabs";
import AppCrmHistory from "./CrmHistory.vue";
import AppSaleSearchBrowse from "@/components/crm/SaleSearchBrowse.vue";
import { ToolbarService } from "@/services/toolbar-service";
import AppCrmEditGeneral from "./CrmEditGeneral.vue";
import { DossierService } from "@/services/dossier-service";
import { DossierConfigService } from "@/services/dossier-config-service";
import AppExtraFieldTab from "@/components/ExtraFieldTab.vue";
import { ExtraFieldTabConfig } from "@/models/dossier-configs/extra-field-tab-config";
import { ExtraFieldNamesConfig } from "@/models/dossier-configs/extra-field-names-config";
import CrmHistory from "@/models/crm/crm-history";
import { CrmService } from "@/services/crm-service";
import { AuthService } from "@/services/auth-service";
import CrmHistoryCall from "@/models/crm/crm-history-call";
import {TranslateResult} from "vue-i18n";
import AppCrmEditExtraFields from "./CrmEditExtraFields.vue";
import AppCrmDocumentsTab from "./CrmDocumentsTab.vue";
import {CrmEditState} from "@/utils/crm/crm-edit-state";
import Crm from "@/models/crm/crm";
import { CalendarEvent } from "@/models/calendar-event";
import { CalendarService } from "@/services";
import { CrmSheduleCalendarOptions } from "@/utils/crm/crm-shedule-calendar-options";

export default Vue.extend({
	data() {
		return {
			id: 0,
			action: null as CrmHistory | null,
			activeTab: 0,
			refresh: 0
		};
	},
	props: {
		state: {
			required: true,
			type: Object as () => CrmEditState
		},
	},
	computed: {
		sortedHistory():CrmHistory[]{
			return [...this.state.crm.History].sort((a:CrmHistory, b:CrmHistory) => {
				if (a.Pinned === b.Pinned) {
					return b.ID - a.ID;
				}
				return a.Pinned ? -1 : 1;
			});
		},
		colWidth():number{
			return this.state.crm.ID ? 4 : 12;
		},
		otherTabColWidth():number{
			if (this.state.crm.ID == 0){
				return 12;
			}
			return 12 - this.colWidth;

		},
		defaultTabs(): DefaultEditTab[] {
			if (this.state.crm.ID == 0) return [];
			return getVisibleDefaultEditTabs(11);
		},
		currentTabKey(): string {
			return this.defaultTabs[this.activeTab]?.key || "";
		},
		tabs(): TranslateResult[] {
			let t:TranslateResult[] = this.defaultTabs.map(t=>t.label());
			if (this.state.crm.ID == 0){
				t = Object.values(this.$ct("tabs"));
			}
			return [...t, ...this.extraFieldNamesConfig.getTabNames()];
		},
		extraFieldNamesConfig():ExtraFieldNamesConfig {
			return DossierConfigService.getExtraFieldNamesConfigs().CrmNames;
		},
		extraFieldTabs():ExtraFieldTabConfig[] {
			return this.extraFieldNamesConfig.getTabs();
		},
		extraFieldTabStart():number {
			return this.state.crm.ID == 0 ? Object.values(this.$ct("tabs")).length : this.defaultTabs.length;
		},
	},
	watch: {
		"crm.StatusID": {
			immediate: true,
			handler(){
				console.log("statusChanged");
			}
		}
	},
	methods: {
		async closeSaleBrowse(){
			await this.state.fetch();
			this.activeTab=0;
		},
		async save(calendarOptions?:CrmSheduleCalendarOptions){
			let isNew = !this.state.crm.ID;
			let crm = isNew ? await CrmService.saveCrm(this.state.crm) : await CrmService.putCrm(this.state.crm);
			if (calendarOptions && crm.TimeSheduled) {
				await this.createCalendarEvent(crm, calendarOptions);
			}
			if (isNew) {
				this.$emit("save", crm);
			} else {
				this.$emit("cancel");
			}
			this.$emit("update:crm", crm);
			this.$wf.notify(this.$ct("common.saved").toString(), "success", 3000, "check");
		},
		async createCalendarEvent(crm:Crm, options:CrmSheduleCalendarOptions){
			if (!crm.TimeSheduled) return;
			let event = new CalendarEvent();
			event.CalendarID = options.calendarId;
			event.CrmID = crm.ID;
			event.StartTimeIsLinkedToCrmTimeSheduled = true;
			event.StartTime = new Date(crm.TimeSheduled);
			event.EndTime = new Date(event.StartTime.getTime() + options.durationMinutes * 60000);
			let contactName = this.state.crm.Contact ? this.state.crm.Contact.getDisplayName() : "";
			let description = this.state.crm.Description.split("\n")[0].substring(0, 60);
			event.Title = [contactName, description].filter(v => v != "").join(" - ");
			await CalendarService.postEvents([event]);
		},
		async updateHistory(value:CrmHistory){
			await CrmService.putCrmHistory([value]);
			await CrmService.syncCrmHistoryDocuments(value);
			let i = this.state.crm.History.findIndex(item => item.ID === value.ID);
			if (i !== -1) {
				this.$set(this.state.crm.History, i, value);
			}
		},
		async saveHistory(value:CrmHistory){
			value.CrmID = this.state.crm.ID;
			value.CreatorID = AuthService.wfUser.ID;
			let result = await CrmService.postCrmHistory([value]);
			let saved = result[0];
			saved.UnprocessedFiles = value.UnprocessedFiles;
			saved.toDeleteFiles = value.toDeleteFiles;
			await CrmService.syncCrmHistoryDocuments(saved);
			this.state.crm.History.unshift(saved);
		},
		async cancel() {
			this.$emit("cancel");
		},
		triggerAction(value:string){
			this.$emit("input",value);
		},
		triggerPhone(value:string){
			let c = new CrmHistory();
			let a = "";
			c.EventTypeID = 2;
			if(this.state.crm.Contact){
				if(this.state.crm.Contact.MainAddress){
					a = this.state.crm.Contact.MainAddress.FirstName;
				}
			}
			c.Props = new CrmHistoryCall({Phone: value,Contact: a});
			this.action = c;
		}
	},
	async mounted() {
		if (this.state.crm.ID) {
			ToolbarService.title = this.$ct("edit-crm");
		} else {
			ToolbarService.title = this.$ct("new-crm");
		}
	},
	async created(){
		await DossierService.getUsers();
	},
	components: {
		AppCrmHistory,
		AppSaleSearchBrowse,
		AppCrmEditExtraFields,
		AppCrmDocumentsTab,
		AppCrmEditGeneral,
		AppExtraFieldTab
	},
	i18nEx: {
		componentPrefix: "components.crm"
	}
});
